/**
 * Mask an account number, showing only the last 4 characters.
 * Short strings (≤ 4 chars) are returned as-is.
 */
export function maskAccountNumber(acct: string): string {
  if (!acct || acct.length <= 4) return acct;
  const visible = acct.slice(-4);
  const masked = '•'.repeat(acct.length - 4);
  return masked + visible;
}
